/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_StubInputs */

const cs_settings_calendar_stub = /** @type {(inputs: Settings_Calendar_StubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojení kalendáře přes Google/Microsoft na serveru zatím není nastavené. Požádejte správce.`)
};

const en_settings_calendar_stub = /** @type {(inputs: Settings_Calendar_StubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google/Microsoft calendar connect is not set up on this server. Ask an admin.`)
};

/**
* | output |
* | --- |
* | "Google/Microsoft calendar connect is not set up on this server. Ask an admin." |
*
* @param {Settings_Calendar_StubInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_stub = /** @type {((inputs?: Settings_Calendar_StubInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_StubInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_stub(inputs)
	return cs_settings_calendar_stub(inputs)
});